import React from 'react'
import { CButton } from '@coreui/react'

const RButtonPrimary = ({ children, type, ...props }) => {
    return <CButton type={type ?? 'button'} size="sm" color='primary' {...props}>{children}</CButton>
}

export default RButtonPrimary
